import { render } from "./SidenavList.vue?vue&type=template&id=530166cc"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/projects/sms_agent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__